var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Insurance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.75 22C9.53343 21.3026 7.68762 19.9298 6.21256 17.8816C4.73752 15.8333 4 13.5095 4 10.9099V4.90082L11.75 2L19.5 4.90082V10.9099C19.5 13.5095 18.7625 15.8333 17.2874 17.8816C15.8124 19.9298 13.9666 21.3026 11.75 22ZM11.75 21.1912C13.7768 20.5404 15.4502 19.2527 16.7701 17.3279C18.09 15.403 18.75 13.2643 18.75 10.9118V5.39374L11.75 2.80882L4.75 5.39374V10.9118C4.75 13.2643 5.40997 15.403 6.72991 17.3279C8.04983 19.2527 9.7232 20.5404 11.75 21.1912Z",
    fill: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6768 15.2499H10.8239V12.3088H7.88269V10.4558H10.8239V7.51465H12.6768V10.4558H15.618V12.3088H12.6768V15.2499Z",
    stroke: "#183883",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/Insurance.643c3fa4e4c4166eed0c2739177a6830.svg";
export { ForwardRef as ReactComponent };